// extracted by mini-css-extract-plugin
export var content = "_cj-3";
export var list = "_cj-4";
export var settingsContent = "_cj-7";
export var settingsPanel = "_cj-8";
export var state = "_cj-6";
export var triggerBadge = "_cj-2";
export var triggerButton = "_cj-1";
export var triggerShell = "_cj-0";
export var unreadDot = "_cj-5";